export default class FileLoader {
	fileType;
	loadFile(_file, _imageId: string) {
		throw new Error('Method not implemented');
	}
	getDataset(_image, _isSameOrientationimageId: string) {
		throw new Error('Method not implemented');
	}
	getStudies(_dataset, _imageId: string) {
		throw new Error('Method not implemented');
	}
}
